import { EsField } from '../../../../services/dtos/riskProducts/rpColumn.dto';

export const DEFAULT_MONITOR_SORT_FIELD: EsField = 'display_name';

export const EXCLUDED_MONITOR_ES_FIELDS = [
  'rating_stability_indicator',
  'potential_rating_action',
  'cs_companyid',
  'rid',
  'cs_sector3_name',
  'cre_previous',
  'cqs_previous',
  'fscore_previous',
  'credit_risk_level_previous',
  'acr_previous',
];

export const COLUMN_PERSISTENCE_KEY = 'monitor-widget-rp-columns';

export const DEFAULT_MONITOR_COLUMNS: EsField[] = [
  'display_name',
  'display_ticker',
  'country_name',
  'model_sector',
  'calc_date',
  'fund_date',
  'cqs',
  'cqs_trend_1y',
  'cqs_volatility',
  'acr',
  'fas',
  'cre_1y',
  'credit_risk_level',
  'credit_risk_trend_6m',
];
